import { Link } from 'react-router';
import { PageShell } from '../components/PageShell';
import { SHORTCUTS } from '../components/play/ShortcutsHint';

export function AboutRoute() {
  return (
    <PageShell eyebrow="About" title="Tonist">
      <div className="two-col">
        <div className="glass panel stack">
          <h3>What it is</h3>
          <div className="prose">
            <p>A mandala you can play. Touch it and a drone sounds at a pitch that is always in tune with the world it lives in: every petal is a degree of the current raga, tuned in just intonation to the tonic at the centre. Rings farther out are the same notes an octave higher; the fire ring at the edge names the twelve keys.</p>
            <p>Lift your finger and the tone hangs and fades over a few seconds. Double-tap and it stays forever, its ring slowly turning like a prayer wheel. Build your own drones from a tanpura, a didgeridoo, a singing bowl, a throat singer, a pipe organ, a Shepard tone, or something you record yourself.</p>
          </div>
          <h3>The five colours</h3>
          <div className="prose">
            <p>The zone hues follow the five Buddha families of the Vajradhatu mandala: white Vairocana at the centre, blue Akshobhya in the east, yellow Ratnasambhava in the south, red Amitabha in the west, green Amoghasiddhi in the north. (The Kalachakra tradition puts blue at the centre instead; we follow the more common Vajradhatu scheme.) The palette is the mineral pigments of thangka painting: gold, cinnabar, azurite, malachite, orpiment, bone white on lamp black.</p>
          </div>
        </div>
        <div className="stack">
          <div className="glass panel stack">
            <h3>Keyboard and mouse</h3>
            <table style={{ borderCollapse: 'collapse', fontSize: 13 }}>
              <tbody>
                {SHORTCUTS.map(([k, v]) => <tr key={k}><td style={{ padding: '6px 12px 6px 0' }}><kbd>{k}</kbd></td><td style={{ padding: '6px 0', color: 'var(--fg-dim)' }}>{v}</td></tr>)}
              </tbody>
            </table>
            <div className="hint">On touch: more fingers for more voices (5 max), two-finger horizontal swipe changes scale, three-finger tap clears latched drones, long-press ramps vibrato in.</div>
          </div>
          <div className="glass panel stack">
            <h3>Accessibility</h3>
            <div className="prose"><p>Every zone is also a button for keyboards and screen readers. The Calm toggle (or your system’s reduced-motion setting) stops rotation and the water; reduced-transparency swaps the glass for solid panels.</p></div>
          </div>
          <div className="glass panel stack">
            <h3>Licenses</h3>
            <div className="prose">
              <p>Tonist is free and not monetised. Sample credits and licenses are on the <Link to="/credits">credits</Link> page. Fonts under the SIL Open Font License. Built with React, Web Audio and WebGL.</p>
            </div>
          </div>
        </div>
      </div>
    </PageShell>
  );
}
